import type { IPassengerCounts } from "@hopper-b2b/types";

import { MINIMUM_ADULT_COUNT } from "../reducer";

export function sumSeatedPassengers(
  adultsCount?: number | null,
  childrenCount?: number | null,
  infantsInSeatCount?: number | null
): number {
  const adults = adultsCount ?? MINIMUM_ADULT_COUNT;
  const children = childrenCount ?? 0;
  const infantsInSeat = infantsInSeatCount ?? 0;

  return Math.max(MINIMUM_ADULT_COUNT, adults + children + infantsInSeat);
}

export function normalizePassengerCounts(counts: {
  adultsCount?: number | null;
  childrenCount?: number | null;
  infantsInSeatCount?: number | null;
  infantsOnLapCount?: number | null;
}): IPassengerCounts {
  return {
    adultsCount: counts.adultsCount ?? MINIMUM_ADULT_COUNT,
    childrenCount: counts.childrenCount ?? 0,
    infantsInSeatCount: counts.infantsInSeatCount ?? 0,
    infantsOnLapCount: counts.infantsOnLapCount ?? 0,
  };
}
